import type { EvidenceStrength } from "@edufadder/shared-types";
import { Chip, evidenceStrengthLabel, evidenceStrengthTone } from "@edufadder/ui";

/** "Well supported by research" / "Research is mixed" / ... — same wording as the extension's notes. */
export function EvidenceChip({ strength }: { strength: EvidenceStrength | string | null | undefined }): JSX.Element | null {
  if (!strength) return null;
  const s = strength as EvidenceStrength;
  return <Chip tone={evidenceStrengthTone(s)}>{evidenceStrengthLabel(s)}</Chip>;
}

export const TOPIC_LABELS: Record<string, string> = {
  learning_styles: "Learning styles",
  digital_natives: "Digital natives",
  neuromyths: "Brain myths",
  learning_pyramid: "Learning pyramid",
  mozart_effect: "Music & intelligence",
  brain_gym: "Brain Gym",
  multitasking: "Multitasking",
  study_strategies: "Study strategies",
  growth_mindset: "Growth mindset",
};

export function topicLabel(topic: string): string {
  return TOPIC_LABELS[topic] ?? topic.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
}
